import React from 'react'

function About() {
  return (
    <div id="About" className="basic-1">
        <div className="container">
            <div className="row">
                <div className="col-lg-6">
                    <div className="text-container">
                        <h1 className="blue">About FalconEye AI Solutions</h1>
                        <p>FalconEye AI Solutions empowers businesses to soar above the competition through cutting-edge artificial intelligence, autonomous agents, Model Context Protocol integration, and blockchain technology.
                        <br/><br/>
                        Like a falcon's keen eyesight that spots opportunities from great heights, our solutions provide businesses with the precision and clarity needed to identify productivity gains, streamline operations, and unlock unprecedented growth potential.
                        <br/><br/>
                        Our comprehensive AI platform delivers:
                        </p>
                        <ul>
                            <li>Advanced AI-powered business intelligence and analytics</li>
                            <li>Autonomous agents that work 24/7 to boost productivity</li>
                            <li>Seamless MCP integration connecting all your data sources</li>
                            <li>Blockchain-secured operations with transparent audit trails</li>
                            <li>Measurable ROI with 25-40% productivity improvements</li>
                        </ul>
                        <p>
                        <br/>
                        With the AI market representing a $4.4 trillion opportunity and 78% of organizations already using AI, the question isn't whether to adopt AI—it's how quickly you can implement solutions that deliver real results.
                        <br/><br/>
                        We are committed to democratizing access to enterprise-grade AI technology, making advanced solutions available to businesses of all sizes.
                        </p>
                    </div>
                </div> 
                <div className="col-lg-6">
                    <div className="image-container">
                        <img className="img-fluid" src="images/details.png" alt="AI Business Intelligence Dashboard" />
                    </div> 
                </div> 
            </div> 
        </div>
    </div>
  )
}

export default About